import { urlBuilder } from '@/connectors/endpoints'
import { ICreateEmployee, IEmployee } from '@/types/employees'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { mapper } from '@/mappers'
import reverseObjUtil from '@/utils/reverse-obj.util'
import { createEmployeeMap } from '@/mappers/employees'

const updateEmployee = (employeeId: number, formData: ICreateEmployee, endPoint: string) => {
  return new AxiosRequestBuilder<IEmployee>({
    url: urlBuilder(endPoint, String(employeeId)),
    method: 'patch',
    data: formData,
    requestMapperFunction: mapper,
    requestMapper: reverseObjUtil(createEmployeeMap)
  }).exec()
}

export default updateEmployee
